module.exports = __webpack_public_path__ + "img/Road1_0 - Copy.087ffdc8.png";